<div class="lookup-editor">
  <input #input type="text" (blur)="onBlur($event)" [(ngModel)]="params.value" disabled="true" (click)="openDialog($event)" *ngIf="this.lookupForceDialog">
  <input #input type="text" (blur)="onBlur($event)" [(ngModel)]="params.value" *ngIf="!this.lookupForceDialog">
  <button mat-icon-button (click)="openDialog($event)">
    <mat-icon>search</mat-icon>
  </button>
</div>
